import { useState } from 'react';

interface PaginationData {
  page: number;
  rowsPerPage: number;
  search?: string;
}

const INITIAL_PAGINATION_DATA: PaginationData = {
  page: 1,
  rowsPerPage: 10,
};

export const usePagination = (initialData?: PaginationData) => {
  const [pagination, setPagination] = useState<PaginationData>(
    initialData || INITIAL_PAGINATION_DATA,
  );

  const setPaginationHandle = (key: keyof PaginationData, value: string | number) => {
    setPagination((prevState) => ({ ...prevState, [key]: value }));
  };

  const resetPagination = () => {
    setPagination(INITIAL_PAGINATION_DATA);
  };

  return {
    onSearch: (value: string | React.ChangeEvent<HTMLInputElement>) => {
      if (typeof value === 'string') {
        setPaginationHandle('search', value);
        setPaginationHandle('page', 1);
      } else if (value?.target) {
        setPaginationHandle('search', value.target.value);
        setPaginationHandle('page', 1);
      }
    },
    onChangePage: (page: number) => setPaginationHandle('page', page),
    onChangeRowsPerPage: (value: string) => {
      setPaginationHandle('rowsPerPage', parseInt(value, 10));
      setPaginationHandle('page', 1);
    },
    pagination,
    resetPagination,
  };
};
